import { HttpMethods, restRequest } from 'common-src/features/rest';

export const getPatientCgmGlucoseReadingsRequest = (query, params) =>
  restRequest({
    uri: 'patientCgmGlucoseReadings',
    query,
    method: HttpMethods.Get,
    ...params,
  });
